import { createApiResponseSchema, type IAPI } from '../../apiResponse';
import type { IValidatedResponse } from '../../httpClient';
import { putRequest } from '../../httpClient';

const schema = createApiResponseSchema();

export async function updateLeaderboardNicknameApi(
  userId: string,
  nickname: string,
): Promise<IValidatedResponse<IAPI>> {
  return putRequest<IAPI>({
    path: `/sys/leaderboard/${userId}/nickname`,
    body: { nickname },
    schema,
  });
}
